import { useGetQuantifyBaseEQLProps } from '@modules/quantify/hooks/useGetQuantifyBaseEQLProps';
import { useShouldAddDenominatorClause } from '@modules/quantify/hooks/useShouldAddDenominatorClause';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { EQLFunctionName, Join } from 'v2/core/repository/eql/types';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { shallow } from 'zustand/shallow';

interface useGetQuantifyDenominatorJoinClauseParams {
  alias: string;
}

export function useGetQuantifyDenominatorJoinClause({
  alias,
}: useGetQuantifyDenominatorJoinClauseParams): Join | undefined {
  const { aggregatePeriod, groupBy, ...eql } = useGetQuantifyBaseEQLProps();
  const {
    shouldShowCooccurringDataPoints,
    formulaID,
    measuredAsCriteria,
    denominatorWhereClause,
  } = useQuantifyStore(({ metadata, query }) => {
    return {
      activeVisualisationType: metadata.activeVisualisationType,
      shouldShowCooccurringDataPoints: metadata.shouldShowCooccurringDataPoints,
      formulaID: query.formulaID,
      measuredAsCriteria: query.measuredAsCriteria,
      denominatorWhereClause: query.denominatorWhereClause,
    };
  }, shallow);
  const shouldAddDenominatorClause = useShouldAddDenominatorClause();

  if (!shouldAddDenominatorClause) {
    return undefined;
  }

  const formulaParams = measuredAsCriteria?.field
    ? [measuredAsCriteria?.field]
    : undefined;

  const functions = [];

  if (!shouldShowCooccurringDataPoints) {
    functions.push({
      name: EQLFunctionName.ApplyTaxonomy,
    });
  }

  functions.push({
    name: formulaID,
    params: formulaParams,
  });

  return {
    eql: {
      ...eql,
      functions,
      whereClause: denominatorWhereClause ?? EmptyWhereClause,
    },
    alias,
  };
}
